<template>
  <div class="pos-rel" @click="onClick">
    <input
      v-model="selection"
      type="number"
      :min="min"
      :max="max"
      :step="step"
      :name="inputName"
      :class="upgradeRequired ? 'hide-arrows' : ''"
      :disabled="disabled"
      @mousedown="onMousedown"
    >
    <donut-upgrade-tag v-if="upgradeRequired" positioning="absolute" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const props = defineProps({
    modelValue: { type: Number, default: null },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
    step: { type: Number, default: 1 },
    inputName: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    paywall: { type: Object, default: null },
  });
  const emit = defineEmits(['update:modelValue']);
  const { getters, dispatch } = useStore();

  const selection = computed({
    get() { return props.modelValue; },
    set(val) { emit('update:modelValue', val); },
  });

  // Paywall
  const upgradeRequired = computed(() => getters.upgradeRequired(props.paywall));
  const onMousedown = (e) => {
    // See the method of the same name in donut-input-text for explanation
    if (upgradeRequired.value) e.preventDefault();
  };
  const onClick = () => {
    // See the method of the same name in donut-input-text for explanation
    dispatch('openUpgradeModalIfRequired', props.paywall);
  };
</script>

<style scoped lang="scss">
  // We want to hide the up and down arrows that change the value when we're displaying the upgrade-tag
  /* Chrome, Safari, Edge, Opera */
  input.hide-arrows::-webkit-outer-spin-button,
  input.hide-arrows::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input.hide-arrows[type=number] {
    -moz-appearance: textfield;
  }
</style>
